import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Chip, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { getEquipmentPartsWithSensorPositionByQuery } from "components/axios/equipmentAxios";
import MainCard from "components/MainCard";
import EquipmentPanel from "./EquipmentPanel";
import EquipmentPartChainGraphs from "./chart/EquipmentPartChainGraphs";
import EquipmentPartSensorsGraphs from "./chart/EquipmentPartSensorsGraphs";
import EquipmentPartsReplaceLayer from "../layer/EquipmentPartsReplaceLayer";

const EquipmentPartListMaintenance = ({equipment, componentId}) => {
    // console.log({"equipment.id": equipment.id})
    const [equipmentParts, setEquipmentParts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();

    useEffect(()=>{
        if (equipment && equipment.id && componentId && componentId !== -1) {
            getEquipmentPartsWithSensorPositionByQuery({"equipment.id" : equipment.id, "masterEquipmentPart.equipmentCtgr.id": componentId, deletedYn : false}).then((data) => {
            //    console.log(data);
                if (data) {
                    const list = data;
                    if (list) {
                        //console.log(list);
                        setEquipmentParts(list);
                        // return list;
                    }
                } else {
                    setEquipmentParts(null);
                    // return null;
                }
            })
        }
        setIsLoading(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[componentId, equipment, isLoading]);

    function renderContent(type, htmlString) {
        return <TableCell align="center">{htmlString}<EquipmentPartsReplaceLayer info={equipment} type={type} setIsLoading={setIsLoading} /></TableCell>;
        // if (type === "EXPIRED") {
        //     return <TableCell align="center">{htmlString}<EquipmentPartsReplaceLayer info={equipment} type={type} setIsLoading={setIsLoading} /></TableCell>;
        // } else if (type === "NORMAL" || type === "ALERT") {
        //     return <TableCell align="center" dangerouslySetInnerHTML={{ __html: htmlString }}></TableCell>;
        // } else {
        //     return <TableCell align="center"></TableCell>;
        // }
    }

    if (isLoading) {
    return (
        <>
        {/* {((equipment?.equipmentCtgr?.parent?.parent?.code === 'EV' || equipment?.equipmentCtgr?.parent?.parent?.code === 'ES') && componentId === -1) ? */}
        {((equipment?.latestEquipmentOp) && componentId === -1) ?
            <EquipmentPanel equipment={equipment} />
        : 
        equipmentParts && equipmentParts.map(function(item, i) {
            //console.log(item);
            let componentName = item.masterEquipmentPart.name;
            // if (item.status === 'NORMAL') {
            //     componentName += '<span class="instate1">'+t('message.common.text.available')+'</span>';
            // } else if (item.status === 'ALERT') {
            //     componentName += '<span class="instate2">'+t('message.common.text.imminent')+'</span>';
            // } else if (item.status === 'EXPIRED') {
            //     // componentName += '     <span class="instate3">'+t('message.common.text.lapse')+'</span>';
            //     // componentName += '<EquipmentPartsReplaceLayer info={equipment} />';
            // }
            return (
            <div key={i}>
                <MainCard className="center_table" content={false}>
                    <TableContainer>
                        <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width">
                            <TableBody>
                                <TableRow className='pop_tr'>
                                    <TableCell className="th" align="center">{item.sensorYn ? t('message.common.subtitle.iot.diagnosis.equipment') : t('message.common.subtitle.material')}</TableCell>
                                    {renderContent(item.status, componentName)}
                                    {/* <TableCell align="center" dangerouslySetInnerHTML={ {__html: componentName} }></TableCell> */}
                                    <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                                    <TableCell align="center"><Chip label={item.position} color="primary" /></TableCell>
                                </TableRow>
                                <TableRow className='pop_tr'>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.last.inspection.date')}</TableCell>
                                    <TableCell align="center" colSpan={3}>{equipment.latestCommYmd}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                
                    {/* {equipment && item.id && item.sensorYn && equipment.gateways && equipment.gateways.length > 0 && equipment.gateways.map(function(gateway, j) {
                        return (
                        <EquipmentPartSensorsMaintenance key={j} equipment={equipment} equipmentPartId={item.id} gateway={gateway}/>
                        )
                    })} */}
                    {item.id && 
                        <EquipmentPartChainGraphs equipment={equipment} equipmentPartId={item.id} diagnosisResultChain={item.diagnosisResultChain} type="popup"/>
                    }
                    {item.sensorPositions && item.id && item.sensorPositions.length > 0 && item.sensorPositions.map(function(sPosition, j) {
                        return (
                        <EquipmentPartSensorsGraphs key={j} equipment={equipment} equipmentPartId={item.id} equipmentPartPosition={item.position} sensorPosition={sPosition} type="popup"/>
                        )
                    })}
                </MainCard>
            </div>
            )
        }) }
        </>
    )
    }
}

export default EquipmentPartListMaintenance;